import {Component, Inject, LOCALE_ID} from '@angular/core';
import {LocalStorageService} from "../../../../base/services/storage/localstorage.service";
import {Locales, MenuTypeKey, MenuTypes} from "../../../../models/global.config";

@Component({
  selector: 'app-blog-layout',
  templateUrl: './blog-layout.component.html',
  styleUrls: ['./blog-layout.component.scss']
})
export class BlogLayoutComponent {

  protected readonly Locales = Locales;
  menuType = MenuTypes.VERTICAL

  constructor(
    @Inject(LOCALE_ID) protected locale: string
  ) {
    LocalStorageService.retrieveAsync(MenuTypeKey.BLOG, (mt) => {
      this.menuType = (mt as MenuTypes) || MenuTypes.VERTICAL
    })
  }

}
